import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'

const PricingTableCell = ({ width, backgroundColor, children, ...props }) => (
  <td width={width} style={{ backgroundColor: 'background.default' }}>
    <Box px={1} py={2} {...props}>
      {children}
    </Box>
  </td>
)

PricingTableCell.propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
  width: PropTypes.string,
}

PricingTableCell.defaultProps = {
  backgroundColor: 'white',
  children: null,
  width: '13%',
}

export default PricingTableCell
